module.exports = __webpack_public_path__ + "static/media/golf3.7c0bd793.jpg";